/*
 * Homeline "Play and win" email games (sections/hl-email-games.liquid).
 *
 *   Shell     one progress spring `o` (0 hidden, 1 open) drives the modal,
 *             the scrim and the edge tab. First open rises into place; ×,
 *             Esc and the scrim tuck the modal into the tab, which plays the
 *             same path back. On a phone it is a bottom sheet whose grabber
 *             can fling it away.
 *   Games     Spin the wheel, Scratch card, Pick a cushion. The prize is
 *             drawn before play, from the section's weights, and each game
 *             is made to land on it.
 *   Claim     the email goes through Shopify's customer form with tags a
 *             Shopify Flow turns into the exact HOME-XXXXXX discount (see
 *             docs/offer-games-flow.md). The page comes back with
 *             ?customer_posted=true and the code is shown.
 *
 * One play per visit: state lives in sessionStorage (hl_game), so a new
 * visit can play again. Within a visit, once seen, only the tab shows on
 * later pages and nothing reopens on its own.
 */
(function () {
  'use strict';

  var KEY = 'hl_game';
  var PICK_KEY = 'hl_game_pick';
  var GAMES = ['spin', 'scratch', 'cushion'];
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[A-Za-z]{2,}$/;
  var MOBILE = '(max-width: 760px)';

  var COPY = {
    spin: ['Give it a spin.', 'Drag the wheel or tap Spin. Every slice is a prize for your home.'],
    scratch: ['Scratch to reveal.', 'Run your finger over the card. Every card wins something for your home.'],
    cushion: ['Pick a cushion.', 'One of these is hiding your prize. Every cushion wins something.']
  };

  /* ─────────────── helpers ─────────────── */

  function cl(x) {
    return Math.max(0, Math.min(1, x));
  }

  function mod(x, m) {
    return ((x % m) + m) % m;
  }

  function rubber(o, d) {
    return (o * d * 0.55) / (d + 0.55 * Math.abs(o));
  }

  function reduced() {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  function mobile() {
    return window.matchMedia(MOBILE).matches;
  }

  function el(tag, cls, html) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (html != null) n.innerHTML = html;
    return n;
  }

  function readState() {
    try {
      var s = JSON.parse(sessionStorage.getItem(KEY) || 'null');
      return s && s.s ? s : { s: 'unseen' };
    } catch (e) {
      return { s: 'unseen' };
    }
  }

  function writeState(patch) {
    var cur = readState();
    Object.keys(patch).forEach(function (k) {
      cur[k] = patch[k];
    });
    cur.at = Date.now();
    try {
      sessionStorage.setItem(KEY, JSON.stringify(cur));
    } catch (e) {}
    return cur;
  }

  // No 0/O/1/I/L, so a code read aloud or typed from the email is unambiguous.
  function token(n) {
    var abc = 'ABCDEFGHJKMNPQRSTUVWXYZ23456789';
    var out = '';
    var bytes = new Uint8Array(n);
    if (window.crypto && crypto.getRandomValues) crypto.getRandomValues(bytes);
    else for (var i = 0; i < n; i++) bytes[i] = Math.floor(Math.random() * 256);
    for (var k = 0; k < n; k++) out += abc[bytes[k] % abc.length];
    return out;
  }

  function shuffle(a) {
    for (var i = a.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var t = a[i];
      a[i] = a[j];
      a[j] = t;
    }
    return a;
  }

  function track(name, data) {
    var payload = Object.assign({ event: name }, data || {});
    try {
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
        Shopify.analytics.publish(name, data || {});
      }
    } catch (e) {}
    try {
      if (Array.isArray(window.dataLayer)) window.dataLayer.push(payload);
    } catch (e) {}
  }

  /* ═════════════ Game 1 · Spin the wheel ═════════════ */

  // Clockwise from the top: $50, $100, $50, $100, $50, $100.
  var SEG_PRIZE = [0, 1, 0, 1, 0, 1];
  var SEG_FILL = ['#39251a', '#e05a29', '#F9F4EF', '#e05a29', '#39251a', '#e05a29'];

  function Spin(shell, host) {
    var self = this;
    this.shell = shell;
    this.theta = 0;
    this.omega = 0;
    this.spinning = false;
    this.done = false;

    var root = el('div', 'eg-spin');
    root.appendChild(el('div', 'eg-spin__stand'));
    root.appendChild(el('div', 'eg-spin__rim'));
    this.bulbs = [];
    for (var i = 0; i < 16; i++) {
      var a = ((i * 22.5 - 90) * Math.PI) / 180;
      var b = el('span', 'eg-spin__bulb' + (i % 2 === 0 ? ' is-on' : ''));
      b.style.setProperty('--cx', Math.cos(a).toFixed(4));
      b.style.setProperty('--cy', Math.sin(a).toFixed(4));
      root.appendChild(b);
      this.bulbs.push(b);
    }

    var R = 96;
    var paths = '';
    var pegs = '';
    this.segPaths = [];
    for (var s = 0; s < 6; s++) {
      var a0 = ((-90 + s * 60) * Math.PI) / 180;
      var a1 = ((-30 + s * 60) * Math.PI) / 180;
      var d = 'M0 0 L' + (R * Math.cos(a0)).toFixed(2) + ' ' + (R * Math.sin(a0)).toFixed(2) +
        ' A' + R + ' ' + R + ' 0 0 1 ' + (R * Math.cos(a1)).toFixed(2) + ' ' + (R * Math.sin(a1)).toFixed(2) + ' Z';
      this.segPaths.push(d);
      paths += '<path d="' + d + '" fill="' + SEG_FILL[s] + '" stroke="rgba(255,255,255,0.9)" stroke-width="1.2"/>';
      pegs += '<circle cx="' + (90 * Math.cos(a0)).toFixed(2) + '" cy="' + (90 * Math.sin(a0)).toFixed(2) + '" r="3" fill="#F9F4EF" stroke="#39251a" stroke-width="0.8"/>';
    }
    var wheel = el('div', 'eg-spin__wheel');
    wheel.innerHTML =
      '<svg viewBox="-100 -100 200 200" aria-hidden="true" focusable="false">' + paths +
      '<path class="eg-spin__win" fill="#fff" d=""/>' + pegs +
      '<circle cx="0" cy="0" r="30" fill="none" stroke="rgba(255,255,255,0.6)" stroke-width="1"/></svg>';
    // Labels are HTML, not SVG text, which some renderers break.
    var prizes = shell.config.prizes;
    for (var l = 0; l < 6; l++) {
      var wrap = el('div', 'eg-spin__label');
      wrap.style.transform = 'rotate(' + (l * 60 + 30) + 'deg)';
      var dark = SEG_FILL[l] !== '#F9F4EF';
      var words = prizes[SEG_PRIZE[l]].wheel || [prizes[SEG_PRIZE[l]].name, ''];
      var inner = el('span');
      inner.style.color = dark ? '#fff' : '#39251a';
      inner.appendChild(el('span', 'eg-spin__l1')).textContent = words[0];
      inner.appendChild(el('span', 'eg-spin__l2')).textContent = words[1];
      wrap.appendChild(inner);
      wheel.appendChild(wrap);
    }
    root.appendChild(wheel);
    root.appendChild(el('div', 'eg-spin__gloss'));
    this.flap = root.appendChild(el('div', 'eg-spin__flap'));
    this.hub = root.appendChild(el('button', 'eg-spin__hub'));
    this.hub.type = 'button';
    this.hub.textContent = 'Spin';
    this.hub.setAttribute('aria-label', 'Spin the wheel');

    this.root = root;
    this.wheel = wheel;
    this.win = wheel.querySelector('.eg-spin__win');
    host.appendChild(root);

    this.hub.addEventListener('click', function () {
      self.spinTo(1500);
    });

    // Drag: the angle follows the pointer around the centre; a flick keeps
    // its speed.
    var drag = null;
    wheel.addEventListener('pointerdown', function (e) {
      if (self.spinning || self.done || e.button > 0) return;
      var r = wheel.getBoundingClientRect();
      var cx = r.left + r.width / 2;
      var cy = r.top + r.height / 2;
      try {
        wheel.setPointerCapture(e.pointerId);
      } catch (err) {}
      drag = { id: e.pointerId, cx: cx, cy: cy, last: Math.atan2(e.clientY - cy, e.clientX - cx), moved: 0, hist: [{ th: self.theta, t: performance.now() }] };
    });
    wheel.addEventListener('pointermove', function (e) {
      if (!drag || e.pointerId !== drag.id) return;
      var a = Math.atan2(e.clientY - drag.cy, e.clientX - drag.cx);
      var da = ((a - drag.last) * 180) / Math.PI;
      if (da > 180) da -= 360;
      if (da < -180) da += 360;
      drag.last = a;
      drag.moved += Math.abs(da);
      var now = performance.now();
      self.theta += da;
      drag.hist.push({ th: self.theta, t: now });
      while (drag.hist.length > 2 && now - drag.hist[0].t > 100) drag.hist.shift();
      self.paint(true);
    });
    var up = function (e) {
      if (!drag || e.pointerId !== drag.id) return;
      var d = drag;
      drag = null;
      self.paint(false);
      if (d.moved < 8) return;
      var a = d.hist[0];
      var b = d.hist[d.hist.length - 1];
      var dt = (b.t - a.t) / 1000;
      var w = dt > 0 ? (b.th - a.th) / dt : 0;
      if (Math.abs(w) < 500) w = (w < 0 ? -1 : 1) * 1400;
      self.spinTo(w);
    };
    wheel.addEventListener('pointerup', up);
    wheel.addEventListener('pointercancel', up);

    this.paint(false);
  }

  // Restored after a win: show the board as played, never play it again.
  Spin.prototype.lock = function () {
    this.done = true;
    this.hub.disabled = true;
    this.hub.textContent = 'Won';
  };

  Spin.prototype.focusTarget = function () {
    return this.hub;
  };

  Spin.prototype.paint = function (dragging) {
    this.wheel.style.transform = 'rotate(' + this.theta.toFixed(2) + 'deg)';
    var blur = Math.min(2.2, Math.abs(this.omega) / 1100);
    this.wheel.style.filter = blur > 0.05 ? 'blur(' + blur.toFixed(2) + 'px)' : '';
    // The flapper kicks back as each peg passes under it.
    var frac = mod(-this.theta, 60) / 60;
    var flap = this.spinning || dragging ? -22 * Math.max(0, 1 - Math.min(frac, 1 - frac) / 0.12) : 0;
    this.flap.style.transform = 'rotate(' + flap.toFixed(2) + 'deg)';
    if (this.spinning) {
      var chase = Math.floor(Math.abs(this.theta) / 14);
      if (chase !== this.chase) {
        this.chase = chase;
        this.bulbs.forEach(function (b, i) {
          b.classList.toggle('is-on', (i + chase) % 3 === 0);
        });
      }
    }
  };

  Spin.prototype.spinTo = function (omega) {
    var self = this;
    if (this.spinning || this.done) return;
    var prize = this.shell.prize;
    var th0 = this.theta;
    var tau = 0.7;
    var sgn = omega < 0 ? -1 : 1;
    var delta = omega * tau;
    if (Math.abs(delta) < 900) delta = sgn * 900;
    var base = th0 + delta;

    // Land on the centre of a slice holding the drawn prize: with slice i
    // under the pointer, −θ ≡ 60i + 30 (mod 360). Of that prize's slices,
    // take the first one at or past the natural stopping point, in the
    // direction of travel.
    var end = null;
    SEG_PRIZE.forEach(function (p, i) {
      if (p !== prize) return;
      var target = -(i * 60 + 30);
      var k = sgn > 0 ? Math.ceil((base - target) / 360) : Math.floor((base - target) / 360);
      var cand = target + k * 360;
      if (end === null || (sgn > 0 ? cand < end : cand > end)) end = cand;
    });
    delta = end - th0;
    var total = tau * 6.5;
    var t0 = performance.now();
    this.spinning = true;
    this.hub.textContent = '…';
    this.hub.disabled = true;
    this.shell.played();
    var lastSeg = Math.floor(mod(-th0, 360) / 60);

    var finish = function () {
      if (!self.spinning) return;
      cancelAnimationFrame(self.raf);
      self.spinning = false;
      self.done = true;
      self.omega = 0;
      self.theta = end;
      self.paint(false);
      var idx = Math.floor(mod(-end, 360) / 60);
      self.win.setAttribute('d', self.segPaths[idx]);
      self.root.classList.add('is-won');
      self.bulbs.forEach(function (b) {
        b.classList.add('is-on');
      });
      self.hub.textContent = 'Won';
      self.shell.won(450);
    };

    if (reduced()) {
      finish();
      return;
    }
    var step = function (now) {
      var t = (now - t0) / 1000;
      if (t >= total) {
        finish();
        return;
      }
      var e = Math.exp(-t / tau);
      self.theta = th0 + delta * (1 - e);
      self.omega = (delta / tau) * e;
      var seg = Math.floor(mod(-self.theta, 360) / 60);
      if (seg !== lastSeg) {
        lastSeg = seg;
        try {
          if (navigator.vibrate && mobile()) navigator.vibrate(4);
        } catch (err) {}
      }
      self.paint(false);
      self.raf = requestAnimationFrame(step);
    };
    this.raf = requestAnimationFrame(step);
    window.setTimeout(finish, total * 1000 + 300);
  };

  /* ═════════════ Game 2 · Scratch card ═════════════ */

  function Scratch(shell, host) {
    var self = this;
    this.shell = shell;
    this.done = false;
    this.strokes = 0;
    this.flakes = [];
    var prize = shell.config.prizes[shell.prize];

    var root = el('div', 'eg-scratch');
    var card = el('div', 'eg-scratch__card');
    card.appendChild(el('div', 'eg-scratch__string'));
    var face = el('div', 'eg-scratch__face');
    var under = el('div', 'eg-scratch__prize');
    under.appendChild(el('span', 'eg-scratch__won')).textContent = 'You won';
    under.appendChild(el('span', 'eg-scratch__name')).textContent = prize.name;
    under.appendChild(el('span', 'eg-scratch__detail')).textContent = prize.detail;
    face.appendChild(under);
    var canvas = el('canvas', 'eg-scratch__canvas');
    canvas.tabIndex = 0;
    canvas.setAttribute('role', 'button');
    canvas.setAttribute('aria-label', 'Scratch card. Drag to scratch, or press Enter to reveal.');
    face.appendChild(canvas);
    card.appendChild(face);
    card.appendChild(el('span', 'eg-scratch__eyelet'));
    this.hint = card.appendChild(
      el('div', 'eg-scratch__hint',
        '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M18 11V6a2 2 0 0 0-4 0v5"/><path d="M14 10V4a2 2 0 0 0-4 0v2"/><path d="M10 10.5V6a2 2 0 0 0-4 0v8"/><path d="M18 8a2 2 0 1 1 4 0v6a8 8 0 0 1-8 8h-2c-2.8 0-4.5-.86-5.99-2.34l-3.6-3.6a2 2 0 0 1 2.83-2.82L7 15"/></svg><span>Drag to scratch</span>')
    );
    root.appendChild(card);
    var meter = root.appendChild(el('div', 'eg-scratch__meter', '<span></span>'));
    this.bar = meter.firstChild;
    this.root = root;
    this.card = card;
    this.canvas = canvas;
    host.appendChild(root);

    this.hintTimer = window.setInterval(function () {
      self.hint.classList.toggle('is-flip');
    }, 1000);

    var last = null;
    var pos = function (e) {
      var r = canvas.getBoundingClientRect();
      // The card is rotated −2.5°; un-rotate the pointer into canvas space.
      var cx = r.left + r.width / 2;
      var cy = r.top + r.height / 2;
      var a = (2.5 * Math.PI) / 180;
      // On a short phone the whole game is scaled to fit (Shell.fit); the
      // canvas itself is still laid out at full size.
      var k = self.shell.fitScale || 1;
      var dx = (e.clientX - cx) / k;
      var dy = (e.clientY - cy) / k;
      return {
        x: dx * Math.cos(a) - dy * Math.sin(a) + canvas.offsetWidth / 2,
        y: dx * Math.sin(a) + dy * Math.cos(a) + canvas.offsetHeight / 2
      };
    };
    canvas.addEventListener('pointerdown', function (e) {
      if (self.done || e.button > 0) return;
      self.ensure();
      try {
        canvas.setPointerCapture(e.pointerId);
      } catch (err) {}
      last = pos(e);
      self.scratch(last, last);
      self.root.classList.add('is-touched');
      window.clearInterval(self.hintTimer);
      if (!self.started) {
        self.started = true;
        self.shell.played();
      }
    });
    canvas.addEventListener('pointermove', function (e) {
      if (!last || self.done) return;
      var p = pos(e);
      self.scratch(last, p);
      last = p;
      self.strokes++;
      if (self.strokes % 2 === 0) self.addFlakes(p);
      if (self.strokes % 6 === 0) self.check();
    });
    var up = function () {
      if (last && !self.done) self.check();
      last = null;
    };
    canvas.addEventListener('pointerup', up);
    canvas.addEventListener('pointercancel', up);
    canvas.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      e.preventDefault();
      if (!self.started) {
        self.started = true;
        self.shell.played();
      }
      self.reveal();
    });
  }

  Scratch.prototype.lock = function () {
    this.done = true;
    window.clearInterval(this.hintTimer);
    this.root.classList.add('is-revealed');
  };

  Scratch.prototype.focusTarget = function () {
    return this.canvas;
  };

  // Drawn once the card has a size: it is built while the modal is hidden.
  Scratch.prototype.ensure = function () {
    var self = this;
    var c = this.canvas;
    var w = c.offsetWidth;
    var h = c.offsetHeight;
    if (!w || !h || (this.drawnW === w && this.drawnH === h)) return;
    this.drawnW = w;
    this.drawnH = h;
    var draw = function () {
      var dpr = window.devicePixelRatio || 1;
      c.width = w * dpr;
      c.height = h * dpr;
      var ctx = c.getContext('2d');
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      ctx.globalCompositeOperation = 'source-over';
      var g = ctx.createLinearGradient(0, 0, w, h);
      g.addColorStop(0, '#4a3123');
      g.addColorStop(0.5, '#39251a');
      g.addColorStop(1, '#2a1b12');
      ctx.fillStyle = g;
      ctx.fillRect(0, 0, w, h);
      var sh = ctx.createLinearGradient(w * 0.2, 0, w * 0.6, h);
      sh.addColorStop(0, 'rgba(255,255,255,0)');
      sh.addColorStop(0.5, 'rgba(255,255,255,0.09)');
      sh.addColorStop(1, 'rgba(255,255,255,0)');
      ctx.fillStyle = sh;
      ctx.fillRect(0, 0, w, h);
      ctx.strokeStyle = 'rgba(249,244,239,0.22)';
      ctx.lineWidth = 1;
      ctx.setLineDash([4, 4]);
      ctx.beginPath();
      if (ctx.roundRect) ctx.roundRect(52.5, 10.5, w - 63, h - 21, 10);
      else ctx.rect(52.5, 10.5, w - 63, h - 21);
      ctx.stroke();
      ctx.setLineDash([]);
      var cx = 52 + (w - 62) / 2;
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      ctx.fillStyle = '#e05a29';
      ctx.font = "700 11px 'DM Sans', sans-serif";
      ctx.fillText('E V E R Y   C A R D   W I N S', cx, h / 2 - 34);
      ctx.fillStyle = '#F9F4EF';
      ctx.font = "700 " + (w < 330 ? 22 : 26) + "px 'Playfair Display', serif";
      ctx.fillText('Scratch to reveal', cx, h / 2);
      ctx.fillStyle = 'rgba(249,244,239,0.7)';
      ctx.font = "500 13px 'DM Sans', sans-serif";
      ctx.fillText('Your prize is under here', cx, h / 2 + 30);
    };
    draw();
    // Redraw with the brand fonts once they load, if nobody has scratched.
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () {
        if (!self.started) draw();
      });
    }
  };

  Scratch.prototype.onShow = function () {
    this.ensure();
  };

  Scratch.prototype.scratch = function (a, b) {
    var ctx = this.canvas.getContext('2d');
    ctx.globalCompositeOperation = 'destination-out';
    // Opaque, or each pass only thins the foil: the dashed border left the
    // stroke colour at 22%.
    ctx.strokeStyle = '#000';
    ctx.globalAlpha = 1;
    ctx.lineCap = 'round';
    ctx.lineJoin = 'round';
    ctx.lineWidth = 44;
    ctx.beginPath();
    ctx.moveTo(a.x, a.y);
    ctx.lineTo(b.x + 0.01, b.y);
    ctx.stroke();
  };

  Scratch.prototype.coverage = function () {
    var c = this.canvas;
    var data = c.getContext('2d').getImageData(0, 0, c.width, c.height).data;
    var step = Math.round(12 * (window.devicePixelRatio || 1));
    var clear = 0;
    var n = 0;
    for (var y = 0; y < c.height; y += step) {
      for (var x = 0; x < c.width; x += step) {
        n++;
        if (data[(y * c.width + x) * 4 + 3] < 40) clear++;
      }
    }
    return n ? clear / n : 0;
  };

  Scratch.prototype.check = function () {
    var c = this.coverage();
    this.bar.style.width = Math.round(Math.min(1, c / 0.5) * 100) + '%';
    if (c > 0.5) this.reveal();
  };

  Scratch.prototype.addFlakes = function (p) {
    var self = this;
    if (reduced()) return;
    for (var i = 0; i < 2; i++) {
      var f = {
        x: p.x, y: p.y,
        vx: (Math.random() - 0.5) * 90,
        vy: -30 - Math.random() * 60,
        r: Math.random() * 360,
        s: 3 + Math.random() * 3,
        life: 0,
        node: el('span', 'eg-scratch__flake')
      };
      f.node.style.width = f.node.style.height = f.s.toFixed(1) + 'px';
      this.card.appendChild(f.node);
      this.flakes.push(f);
    }
    while (this.flakes.length > 40) {
      var old = this.flakes.shift();
      old.node.remove();
    }
    if (this.fraf) return;
    var last = performance.now();
    var step = function (now) {
      var dt = Math.min(1 / 30, (now - last) / 1000);
      last = now;
      self.flakes = self.flakes.filter(function (f) {
        f.vy += 700 * dt;
        f.x += f.vx * dt;
        f.y += f.vy * dt;
        f.r += 400 * dt;
        f.life += dt;
        if (f.life >= 0.9) {
          f.node.remove();
          return false;
        }
        f.node.style.transform = 'translate(' + f.x.toFixed(1) + 'px,' + f.y.toFixed(1) + 'px) rotate(' + f.r.toFixed(0) + 'deg)';
        f.node.style.opacity = (1 - f.life / 0.9).toFixed(2);
        return true;
      });
      self.fraf = self.flakes.length ? requestAnimationFrame(step) : null;
    };
    this.fraf = requestAnimationFrame(step);
  };

  Scratch.prototype.reveal = function () {
    if (this.done) return;
    this.done = true;
    window.clearInterval(this.hintTimer);
    this.bar.style.width = '100%';
    this.root.classList.add('is-revealed');
    this.shell.won(500);
  };

  /* ═════════════ Game 3 · Pick a cushion ═════════════ */

  var CUSHIONS = [
    ['#F9F4EF', '#8A7568', 'rgba(57,37,26,0.28)'],
    ['#e05a29', '#c44e20', 'rgba(255,255,255,0.5)'],
    ['#39251a', '#1f140d', 'rgba(255,255,255,0.32)']
  ];

  function Cushion(shell, host) {
    var self = this;
    this.shell = shell;
    this.picked = null;

    var root = el('div', 'eg-cushion');
    var sofa = el('div', 'eg-cushion__sofa');
    sofa.appendChild(el('div', 'eg-cushion__back'));
    sofa.appendChild(el('div', 'eg-cushion__seat'));
    sofa.appendChild(el('span', 'eg-cushion__leg eg-cushion__leg--l'));
    sofa.appendChild(el('span', 'eg-cushion__leg eg-cushion__leg--r'));
    var row = el('div', 'eg-cushion__row');
    this.slots = [];
    this.btns = [];
    for (var i = 0; i < 3; i++) {
      var slot = el('div', 'eg-cushion__slot');
      var tag = el('div', 'eg-cushion__tag');
      var btn = el('button', 'eg-cushion__btn');
      btn.type = 'button';
      btn.setAttribute('aria-label', 'Cushion ' + (i + 1));
      btn.style.setProperty('--fill', CUSHIONS[i][0]);
      btn.style.setProperty('--tuft', CUSHIONS[i][1]);
      btn.style.setProperty('--stitch', CUSHIONS[i][2]);
      slot.appendChild(tag);
      slot.appendChild(btn);
      row.appendChild(slot);
      this.slots.push(slot);
      this.btns.push(btn);
    }
    sofa.appendChild(row);
    sofa.appendChild(el('div', 'eg-cushion__arm eg-cushion__arm--l'));
    sofa.appendChild(el('div', 'eg-cushion__arm eg-cushion__arm--r'));
    root.appendChild(sofa);
    root.appendChild(el('span', 'eg-hint')).textContent = 'Tap a cushion, or flick it up';
    this.root = root;
    host.appendChild(root);

    this.btns.forEach(function (btn, i) {
      var d = null;
      btn.addEventListener('pointerdown', function (e) {
        if (self.picked !== null || e.button > 0) return;
        try {
          btn.setPointerCapture(e.pointerId);
        } catch (err) {}
        d = { id: e.pointerId, sy: e.clientY, moved: false, y: 0, hist: [{ y: 0, t: performance.now() }] };
        btn.classList.add('is-press');
      });
      btn.addEventListener('pointermove', function (e) {
        if (!d || e.pointerId !== d.id) return;
        var dy = e.clientY - d.sy;
        if (!d.moved && Math.abs(dy) < 6) return;
        d.moved = true;
        var y = dy < 0 ? dy : rubber(dy, 60);
        var now = performance.now();
        d.y = y;
        d.hist.push({ y: y, t: now });
        while (d.hist.length > 2 && now - d.hist[0].t > 100) d.hist.shift();
        btn.classList.remove('is-press');
        btn.classList.add('is-drag');
        btn.style.transform = 'translateY(' + y.toFixed(1) + 'px) scale(1.05)';
      });
      var up = function (e) {
        if (!d || e.pointerId !== d.id) return;
        var a = d.hist[0];
        var b = d.hist[d.hist.length - 1];
        var dt = (b.t - a.t) / 1000;
        var v = dt > 0 ? (b.y - a.y) / dt : 0;
        var tap = !d.moved;
        var flick = d.y < -40 || v < -500;
        d = null;
        btn.classList.remove('is-press', 'is-drag');
        btn.style.transform = '';
        if (e.type === 'pointercancel') return;
        if (tap || flick) self.pick(i);
      };
      btn.addEventListener('pointerup', up);
      btn.addEventListener('pointercancel', up);
      // Keyboard: Enter or Space picks.
      btn.addEventListener('click', function (e) {
        if (e.detail === 0) self.pick(i);
      });
    });
  }

  Cushion.prototype.lock = function () {
    this.picked = -1;
    this.btns.forEach(function (b) {
      b.disabled = true;
    });
    this.root.classList.add('is-done');
  };

  Cushion.prototype.focusTarget = function () {
    return this.btns[1];
  };

  Cushion.prototype.pick = function (i) {
    var self = this;
    if (this.picked !== null) return;
    this.picked = i;
    this.shell.played();
    // The picked cushion hides the drawn prize; the other two one of each.
    var prizes = this.shell.config.prizes;
    var rest = shuffle(prizes.map(function (p, n) {
      return n;
    }));
    this.slots.forEach(function (slot, n) {
      var p = n === i ? self.shell.prize : rest.shift();
      slot.querySelector('.eg-cushion__tag').textContent = prizes[p].name;
      self.btns[n].disabled = true;
    });
    this.slots[i].classList.add('is-picked');
    this.root.classList.add('is-done');
    window.setTimeout(function () {
      self.root.classList.add('is-others');
    }, reduced() ? 0 : 850);
    this.shell.won(reduced() ? 300 : 1500);
  };

  var GAME_CLASSES = { spin: Spin, scratch: Scratch, cushion: Cushion };

  /* ═════════════ The shell ═════════════ */

  function Shell(root) {
    var self = this;
    this.root = root;
    this.config = JSON.parse(root.querySelector('[data-eg-config]').textContent);
    this.modal = root.querySelector('[data-eg-modal]');
    this.scrim = root.querySelector('[data-eg-scrim]');
    this.stage = root.querySelector('[data-eg-game]');
    this.grab = root.querySelector('[data-eg-grab]');
    this.closeBtn = root.querySelector('[data-eg-close]');
    this.states = {};
    Array.prototype.forEach.call(root.querySelectorAll('[data-eg-state]'), function (n) {
      self.states[n.getAttribute('data-eg-state')] = n;
    });
    this.form = root.querySelector('[data-eg-form]');
    this.email = root.querySelector('[data-eg-email]');
    this.error = root.querySelector('[data-eg-error]');
    this.submitBtn = root.querySelector('[data-eg-submit]');
    this.tab = document.querySelector('[data-eg-tab]');
    this.tabText = document.querySelector('[data-eg-tab-text]');
    this.signup = document.querySelector('[data-eg-signup]');

    // Fixed overlays live directly under <body>, clear of any transformed
    // ancestor.
    document.body.appendChild(root);
    if (this.tab) document.body.appendChild(this.tab);
    root.hidden = false;

    this.o = 0;
    this.v = 0;
    this.target = 0;
    this.dy = 0;
    this.fromTab = false;
    this.triggered = false;

    this.closeBtn.addEventListener('click', function () {
      self.minimise();
    });
    this.scrim.addEventListener('click', function () {
      self.minimise();
    });
    if (this.tab) {
      this.tab.addEventListener('click', function () {
        self.restore();
      });
    }
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && self.target === 1) self.minimise();
      if (e.key === 'Tab' && self.target === 1) self.trap(e);
    });
    document.addEventListener('click', function (e) {
      var t = e.target.closest && e.target.closest('[data-hl-game-open]');
      if (!t) return;
      e.preventDefault();
      if (self.triggered) self.restore();
      else self.firstOpen();
    });
    this.form.addEventListener('submit', function (e) {
      e.preventDefault();
      self.claim();
    });
    this.email.addEventListener('input', function () {
      if (EMAIL_RE.test(self.email.value.trim())) self.showError(false);
    });
    root.querySelector('[data-eg-copy]').addEventListener('click', function () {
      self.copy(this);
    });

    this.bindSheet();
    this.bindCovers();
    this.fitScale = 1;
    window.addEventListener('resize', function () {
      self.fit();
    });
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () {
        self.fit();
      });
    }
    this.arm();
  }

  /* ---------- which game, which prize ---------- */

  Shell.prototype.pickGame = function (requested) {
    if (GAMES.indexOf(requested) !== -1) return requested;
    var mode = this.config.game;
    if (GAMES.indexOf(mode) !== -1) return mode;
    // Rotate: one game per visitor, kept for that visitor.
    var saved = null;
    try {
      saved = localStorage.getItem(PICK_KEY);
    } catch (e) {}
    if (GAMES.indexOf(saved) !== -1) return saved;
    var pick = GAMES[Math.floor(Math.random() * GAMES.length)];
    try {
      localStorage.setItem(PICK_KEY, pick);
    } catch (e) {}
    return pick;
  };

  Shell.prototype.drawPrize = function () {
    var w = (this.config.weights || []).map(Number);
    var n = this.config.prizes.length;
    if (w.length !== n || !w.some(function (x) { return x > 0; })) w = [50, 30].slice(0, n);
    var sum = w.reduce(function (a, b) {
      return a + Math.max(0, b);
    }, 0);
    var r = Math.random() * sum;
    for (var i = 0; i < n; i++) {
      r -= Math.max(0, w[i]);
      if (r < 0) return i;
    }
    return 0;
  };

  Shell.prototype.mount = function (game, state) {
    this.game = game;
    this.stage.textContent = '';
    // A saved prize that is no longer offered is redrawn.
    this.prize = state && typeof state.prize === 'number' && this.config.prizes[state.prize] ? state.prize : this.drawPrize();
    this.instance = new GAME_CLASSES[game](this, this.stage);
    this.root.querySelector('[data-eg-play-head]').textContent = COPY[game][0];
    this.root.querySelector('[data-eg-play-body]').textContent = COPY[game][1];
    this.root.setAttribute('data-game', game);
    this.fit();
  };

  /* ---------- phases ---------- */

  Shell.prototype.setPhase = function (phase) {
    var self = this;
    this.phase = phase;
    Object.keys(this.states).forEach(function (k) {
      var on = k === phase;
      self.states[k].classList.toggle('is-on', on);
      self.states[k].setAttribute('aria-hidden', on ? 'false' : 'true');
      if ('inert' in self.states[k]) self.states[k].inert = !on;
    });
    var label = phase === 'won' ? 'Claim your prize' : phase === 'claimed' ? 'Your code' : 'Play and win';
    if (this.tabText) this.tabText.textContent = label;
    if (this.tab) this.tab.setAttribute('aria-label', label);
    var prize = this.config.prizes[this.prize] || this.config.prizes[0];
    if (phase === 'won') {
      this.root.querySelector('[data-eg-won-head]').textContent = prize.head;
      this.root.querySelector('[data-eg-won-detail]').textContent = prize.detail;
    }
    if (phase === 'claimed') {
      var st = readState();
      this.root.querySelector('[data-eg-claimed-body]').textContent =
        'We’ve sent ' + prize.name + ' to ' + (st.email || 'your inbox') + '. Here’s your code in the meantime.';
      this.root.querySelector('[data-eg-code]').textContent = st.code || '';
      this.root.querySelector('[data-eg-claimed-fine]').textContent =
        prize.detail + ' Online only. One code per order. Valid for ' + (this.config.codeDays || 30) + ' days.';
    }
    this.fit();
  };

  // Called by a game the moment the visitor commits to a go.
  Shell.prototype.played = function () {
    track('game_play', { game: this.game });
  };

  // Called by a game when its result is on screen.
  Shell.prototype.won = function (delay) {
    var self = this;
    writeState({ s: 'won', game: this.game, prize: this.prize });
    track('game_win', { game: this.game, prize: this.config.prizes[this.prize].id });
    window.setTimeout(function () {
      self.setPhase('won');
      if (self.target === 1 && !mobile()) self.email.focus({ preventScroll: true });
    }, delay || 0);
  };

  Shell.prototype.showError = function (on) {
    this.states.won.classList.toggle('is-invalid', on);
    this.error.hidden = !on;
    this.email.setAttribute('aria-invalid', on ? 'true' : 'false');
  };

  /* ---------- claim ---------- */

  Shell.prototype.claim = function () {
    var self = this;
    var value = this.email.value.trim();
    if (!EMAIL_RE.test(value)) {
      this.showError(true);
      this.email.focus();
      return;
    }
    this.showError(false);
    var prize = this.config.prizes[this.prize];
    var code = 'HOME-' + token(6);
    var tag = this.config.tag || 'offer-game';
    // offer-game-win-<UTC yyyymmddhhmmss>-<prize>-<code> is the one the Flow
    // reads. A returning customer collects one per visit, and Shopify sorts
    // tags alphabetically, so the fixed-width timestamp makes the newest win
    // sort last. The prize and code tags are kept for reporting.
    var stamp = new Date().toISOString().replace(/[^0-9]/g, '').slice(0, 14);
    var tags = [
      tag,
      tag + '-' + this.game,
      tag + '-prize-' + prize.id,
      tag + '-code-' + code,
      tag + '-win-' + stamp + '-' + prize.id + '-' + code
    ].join(', ');
    writeState({ s: 'pending', game: this.game, prize: this.prize, code: code, email: value });
    track('game_claim', { game: this.game, prize: prize.id });

    // Theme editor, or no form on the page: show the code, send nothing.
    if (!this.signup || this.config.designMode) {
      writeState({ s: 'claimed' });
      this.setPhase('claimed');
      return;
    }
    this.submitBtn.disabled = true;
    this.submitBtn.textContent = 'Sending…';
    this.signup.elements['contact[email]'].value = value;
    this.signup.elements['contact[tags]'].value = tags;
    var sent = false;
    var go = function () {
      if (sent) return;
      sent = true;
      self.signup.submit();
    };
    var captcha = window.Shopify && window.Shopify.captcha;
    if (captcha && typeof captcha.protect === 'function') {
      captcha.protect(this.signup, go);
      // If the captcha never reports ready, send anyway; Shopify will
      // challenge the visitor if it wants to.
      window.setTimeout(go, 6000);
    } else {
      go();
    }
  };

  Shell.prototype.copy = function (btn) {
    var code = readState().code || '';
    var done = function () {
      btn.textContent = 'Copied';
      window.setTimeout(function () {
        btn.textContent = 'Copy';
      }, 2000);
    };
    if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(code).then(done, done);
    else done();
  };

  /* ---------- open, tuck away, restore ---------- */

  Shell.prototype.firstOpen = function () {
    if (this.triggered) return;
    this.triggered = true;
    this.fromTab = false;
    if (this.tab) this.tab.hidden = false;
    if (readState().s === 'unseen') writeState({ s: 'open', game: this.game, prize: this.prize });
    track('game_view', { game: this.game });
    this.go(1);
  };

  Shell.prototype.minimise = function () {
    if (this.target === 0) return;
    this.fromTab = true;
    var st = readState();
    if (st.s === 'open' || st.s === 'unseen') writeState({ s: 'min' });
    track('game_minimise', { game: this.game, phase: this.phase });
    this.go(0);
  };

  Shell.prototype.restore = function () {
    this.triggered = true;
    this.fromTab = true;
    if (this.tab) this.tab.hidden = false;
    this.go(1);
  };

  Shell.prototype.go = function (target, v0) {
    var self = this;
    this.target = target;
    if (typeof v0 === 'number') this.v = v0;
    cancelAnimationFrame(this.raf);
    window.clearTimeout(this.fallback);

    this.root.classList.toggle('is-live', target === 1);
    document.documentElement.classList.toggle('hl-eg-open', target === 1);
    if (target === 1) {
      this.fit();
      this.lastFocus = document.activeElement;
      if (this.instance && this.instance.onShow) {
        // The scratch card needs a laid-out size to draw into.
        window.requestAnimationFrame(function () {
          self.instance.onShow();
        });
      }
    }

    var settle = function () {
      self.o = target;
      self.v = 0;
      self.raf = null;
      self.paint();
      if (target === 1) {
        var f = self.phase === 'won' ? self.email : self.phase === 'claimed' ? self.root.querySelector('[data-eg-copy]') : self.instance && self.instance.focusTarget();
        if (f && !(self.phase === 'won' && mobile())) f.focus({ preventScroll: true });
      } else if (self.tab && !self.tab.hidden) {
        self.tab.focus({ preventScroll: true });
      }
    };

    if (reduced()) {
      settle();
      return;
    }
    var opening = target === 1;
    var resp = opening ? 0.44 : 0.36;
    var damp = opening ? 0.86 : 1;
    if (opening && this.fromTab) resp = 0.4;
    var last = performance.now();
    var step = function (now) {
      var dt = Math.min(1 / 30, (now - last) / 1000);
      last = now;
      var k = Math.pow((2 * Math.PI) / resp, 2);
      var c = (4 * Math.PI * damp) / resp;
      for (var i = 0; i < 4; i++) {
        var a = -k * (self.o - target) - c * self.v;
        self.v += (a * dt) / 4;
        self.o += (self.v * dt) / 4;
      }
      if (Math.abs(self.o - target) < 0.002 && Math.abs(self.v) < 0.02) {
        settle();
        return;
      }
      self.paint();
      self.raf = requestAnimationFrame(step);
    };
    this.raf = requestAnimationFrame(step);
    // A throttled frame loop (background tab) still ends in the right place.
    this.fallback = window.setTimeout(function () {
      if (self.raf && self.target === target) {
        cancelAnimationFrame(self.raf);
        settle();
      }
    }, 1400);
  };

  Shell.prototype.paint = function () {
    var o = this.o;
    var m = this.modal.style;
    var mob = mobile();
    if (mob) {
      m.transformOrigin = '50% 100%';
      m.transform = 'translateY(calc(' + ((1 - o) * 110).toFixed(2) + '% + ' + this.dy.toFixed(1) + 'px))';
      m.opacity = cl(o * 4).toFixed(3);
      m.filter = '';
    } else if (this.fromTab) {
      m.transformOrigin = '100% 85%';
      m.transform = 'translateX(' + ((1 - o) * 320).toFixed(1) + 'px) scale(' + (0.12 + 0.88 * o).toFixed(3) + ')';
      m.opacity = cl((o - 0.15) / 0.5).toFixed(3);
      m.filter = o < 0.995 ? 'blur(' + ((1 - o) * 8).toFixed(2) + 'px)' : '';
    } else {
      m.transformOrigin = '50% 50%';
      m.transform = 'translateY(' + ((1 - o) * 24).toFixed(1) + 'px) scale(' + (0.94 + 0.06 * o).toFixed(3) + ')';
      m.opacity = cl(o / 0.6).toFixed(3);
      m.filter = o < 0.995 ? 'blur(' + ((1 - o) * 10).toFixed(2) + 'px)' : '';
    }
    var H = this.modal.offsetHeight || 600;
    var scrim = (mob ? 0.3 : 0.38) * o * (mob ? cl(1 - this.dy / H) : 1);
    this.scrim.style.opacity = scrim.toFixed(3);
    this.scrim.style.pointerEvents = o > 0.5 ? 'auto' : 'none';
    this.root.style.visibility = o <= 0.001 && this.target === 0 ? 'hidden' : '';

    if (this.tab) {
      var a = this.triggered ? cl((0.55 - o) / 0.45) : 0;
      this.tab.style.transform = 'translateX(' + ((1 - a) * 100).toFixed(1) + '%)';
      this.tab.style.opacity = cl(a * 1.4).toFixed(3);
      this.tab.style.pointerEvents = a > 0.5 ? 'auto' : 'none';
    }
  };

  // Keep Tab inside the dialog while it is open.
  Shell.prototype.trap = function (e) {
    var items = Array.prototype.filter.call(
      this.modal.querySelectorAll('button, input, [tabindex="0"]'),
      function (n) {
        return !n.disabled && n.offsetParent !== null && !n.closest('[inert]');
      }
    );
    if (!items.length) return;
    var first = items[0];
    var last = items[items.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  };

  /* ---------- phone sheet: fit the whole thing on one screen ---------- */

  /*
    The sheet is the game stage stacked over the copy. Where the screen is too
    short for both at full size (most phones once the browser's toolbars and
    the tab bar are counted), the stage gives up height and the game scales
    down inside it, so the sheet never scrolls. Measured rather than set by
    breakpoints: the room depends on the phone, its toolbars, the tab bar and
    which phase's copy is up. The copy keeps its full size; the game shrinks.
  */
  Shell.prototype.fit = function () {
    var stage = this.stage.parentNode;
    var game = this.stage;
    var copy = this.modal.querySelector('.hl-eg__copy');
    var wrap = this.modal.parentNode;
    var clear = function (self) {
      stage.style.removeProperty('--eg-stage-h');
      game.style.removeProperty('--eg-fit');
      self.fitScale = 1;
    };
    // Measure the natural layout, not the last fit.
    clear(this);
    if (!mobile() || !copy) return;

    var cs = window.getComputedStyle(stage);
    var padY = parseFloat(cs.paddingTop) + parseFloat(cs.paddingBottom);
    var padX = parseFloat(cs.paddingLeft) + parseFloat(cs.paddingRight);
    var gameH = game.offsetHeight;
    var gameW = game.offsetWidth;
    var mcs = window.getComputedStyle(this.modal);
    var border = parseFloat(mcs.borderTopWidth) + parseFloat(mcs.borderBottomWidth);
    // One px of slack so rounding never leaves a scroll.
    var room = Math.floor(wrap.clientHeight - border - copy.offsetHeight) - 1;
    var full = Math.max(parseFloat(cs.minHeight) || 0, gameH + padY);
    if (!gameH || room >= full) return;

    var s = Math.min(1, (room - padY) / gameH, (stage.clientWidth - padX) / gameW);
    s = Math.max(0.45, s);
    stage.style.setProperty('--eg-stage-h', Math.max(0, room) + 'px');
    game.style.setProperty('--eg-fit', s.toFixed(3));
    this.fitScale = s;
  };

  /* ---------- phone sheet: drag the grabber down to put it away ---------- */

  Shell.prototype.bindSheet = function () {
    var self = this;
    var g = this.grab;
    if (!g) return;
    var s = null;
    g.addEventListener('pointerdown', function (e) {
      if (e.button > 0 || self.target !== 1) return;
      try {
        g.setPointerCapture(e.pointerId);
      } catch (err) {}
      cancelAnimationFrame(self.raf);
      self.modal.classList.remove('is-snapping');
      s = { id: e.pointerId, sy: e.clientY, hist: [{ y: 0, t: performance.now() }] };
    });
    g.addEventListener('pointermove', function (e) {
      if (!s || e.pointerId !== s.id) return;
      var raw = e.clientY - s.sy;
      var dy = raw > 0 ? raw : -rubber(-raw, 200);
      var now = performance.now();
      s.hist.push({ y: dy, t: now });
      while (s.hist.length > 2 && now - s.hist[0].t > 100) s.hist.shift();
      self.dy = dy;
      self.paint();
    });
    var up = function (e) {
      if (!s || e.pointerId !== s.id) return;
      var H = self.modal.offsetHeight || 600;
      var a = s.hist[0];
      var b = s.hist[s.hist.length - 1];
      var dt = (b.t - a.t) / 1000;
      var v = dt > 0 ? (b.y - a.y) / dt : 0;
      var proj = self.dy + ((v / 1000) * 0.99) / 0.01;
      var dy = self.dy;
      s = null;
      if (dy > H * 0.3 || proj > H * 0.55) {
        // Carry the finger's speed into the spring that tucks it away.
        self.dy = 0;
        self.o = cl(1 - dy / (H * 1.1));
        self.fromTab = true;
        var st = readState();
        if (st.s === 'open') writeState({ s: 'min' });
        track('game_minimise', { game: self.game, phase: self.phase });
        self.go(0, -v / (H * 1.1));
      } else {
        self.modal.classList.add('is-snapping');
        self.dy = 0;
        self.paint();
        window.setTimeout(function () {
          self.modal.classList.remove('is-snapping');
        }, 420);
      }
    };
    g.addEventListener('pointerup', up);
    g.addEventListener('pointercancel', up);
  };

  /* ---------- out of the way of the tab bar's sheets and the cart bar ---------- */

  Shell.prototype.bindCovers = function () {
    var self = this;
    if (!this.tab) return;
    var tabbar = false;
    var paint = function () {
      var covered = tabbar || !!document.querySelector('sticky-header.is-search, [data-mc-bar].is-shown');
      self.tab.classList.toggle('is-covered', covered);
    };
    document.addEventListener('hl-tabbar:state', function (e) {
      var d = e.detail || {};
      tabbar = !!(d.searching || d.shopOpen);
      paint();
    });
    if ('MutationObserver' in window) {
      var mo = new MutationObserver(paint);
      ['sticky-header', '[data-mc-bar]'].forEach(function (sel) {
        var n = document.querySelector(sel);
        if (n) mo.observe(n, { attributes: true, attributeFilter: ['class'] });
      });
    }
  };

  /* ---------- when to show ---------- */

  Shell.prototype.arm = function () {
    var self = this;
    var params = new URLSearchParams(location.search);
    var test = params.get('hl_game');
    if (test === 'reset') {
      try {
        sessionStorage.removeItem(KEY);
      } catch (e) {}
      test = null;
    }
    var st = readState();

    // Back from the customer form: the claim went through.
    if (st.s === 'pending') {
      if (params.get('customer_posted') === 'true') {
        st = writeState({ s: 'claimed' });
        if (history.replaceState) {
          var url = new URL(location.href);
          url.searchParams.delete('customer_posted');
          history.replaceState(null, '', url.pathname + url.search + url.hash);
        }
        this.mount(GAMES.indexOf(st.game) !== -1 ? st.game : this.pickGame(), st);
        this.markPlayed();
        this.setPhase('claimed');
        this.triggered = true;
        if (this.tab) this.tab.hidden = false;
        this.go(1);
        return;
      }
      // The form bounced (or was abandoned): ask for the email again.
      st = writeState({ s: 'won' });
    }

    if (GAMES.indexOf(test) !== -1) {
      this.mount(test, null);
      this.setPhase('play');
      this.firstOpen();
      return;
    }

    var game = GAMES.indexOf(st.game) !== -1 ? st.game : this.pickGame();
    this.mount(game, st.s === 'won' || st.s === 'claimed' ? st : null);
    this.setPhase(st.s === 'won' ? 'won' : st.s === 'claimed' ? 'claimed' : 'play');
    if ((st.s === 'won' || st.s === 'claimed') && typeof st.prize === 'number') this.markPlayed();

    // Already seen this visit: only the tab, never an automatic reopen.
    if (st.s !== 'unseen') {
      this.triggered = true;
      if (this.tab) this.tab.hidden = false;
      this.paint();
      return;
    }

    if (!this.config.enabled || this.config.designMode) {
      this.paint();
      return;
    }
    var trigger = Math.max(60, Number(this.config.trigger) || 240);
    var onScroll = function () {
      var max = document.documentElement.scrollHeight - window.innerHeight;
      var y = window.scrollY || window.pageYOffset;
      // 240px, or a quarter of a short page, whichever comes first.
      if (y > trigger || (max > 0 && y / max > 0.25 && y > 60)) {
        window.removeEventListener('scroll', onScroll);
        self.firstOpen();
      }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    this.paint();
  };

  Shell.prototype.markPlayed = function () {
    if (this.instance && this.instance.lock) this.instance.lock();
  };

  function init() {
    var root = document.querySelector('[data-hl-eg]');
    if (!root || root.hlEg) return;
    root.hlEg = new Shell(root);
    window.HLEmailGames = {
      open: function () {
        if (root.hlEg.triggered) root.hlEg.restore();
        else root.hlEg.firstOpen();
      }
    };
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
